<template>
	<div class="box">
		<CustomTable
            id_table="tiers_article_remise"
            ref="tiers_article_remise"
            :items="remises"
            :busy.sync="table_busy"
            primaryKey="articlestiers_id"
            :hide_if_empty="true"
        />
        <b-modal ref="modal" hide-footer>
        	<template v-if="form.articlestiers_id" v-slot:modal-title>
				{{ $t("invoice.edit_remise_tiers") }}
			</template>
        	<template v-else v-slot:modal-title>
				{{ $t("invoice.add_remise_tiers") }}
			</template>

			<div class="row">
                <div class="col-12 form-group">
                    <label for="articles" class="col-form-label">{{ $t("acte.article") }} *</label>
                    <e-select
                        v-model="form.articlestiers_articles"
                        id="articles"
                        track-by="articles_label"
                        label="articles_label"
                        :options="articles_filtered"
                        :searchable="true"
                        :allow-empty="true"
                        :loading="loading_article"
                        :internal-search="false"
                        @search-change="onSearchArticle"
                        @input="articleUpdated"
                    >
                        <template slot="option" slot-scope="{ option }">{{ option.articles_label }} ({{ option.ht_format }}) - {{ option.entity_label }}</template>
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.articles_label }} ({{ option.ht_format }} - {{ option.entity_label }})</template>
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
                </div>
                <div class="col-12 form-group">
                	<label for="discount">{{ $t("invoice.prix_unitaire") }}</label>
                	<b-form-checkbox class="d-inline ml-2" switch v-model="show_discount" id="discount">
						{{ $t("invoice.remise") }}
					</b-form-checkbox>
                </div>
                <template v-if="show_discount">
	            	<div class="col-6 form-group">
						<label for="discount_type">{{ $t('compta.form.discount_type') }} *</label>
						<e-select
							v-model="form.articlestiers_discount_type"
							id="discount_type"
							track-by="invoicediscounttype_id"
							label="invoicediscounttype_label"
							:options="discount_type"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
						>
							<template slot="singleLabel" slot-scope="{ option }">{{ $t(option.invoicediscounttype_label) }}</template>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>
					<div class="col-6 form-group">
						<label for="discount_value">{{ $t('compta.form.discount_value') }} *</label>
						<input id="discount_value" type="text" class="form-control" v-model="form.articlestiers_discount_value">
					</div>
				</template>
				<div v-else class="col-12 form-group">
					<label for="htunit">{{ $t('invoice.prix_unit_pref') }} *</label>
					<input id="htunit" type="text" class="form-control" v-model="form.articlestiers_htunit">
				</div>
				<div v-if="show_ae_message" class="col-12">
					<b-alert variant="warning" show>
        				{{ $t("invoice.remise_alreay_exists") }}
        			</b-alert>
				</div>
				<div class="col-12 text-center">
					<b-button @click="save" variant="primary">{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']"/></b-button>
				</div>
            </div>
        </b-modal>
	</div>
</template>

<script type="text/javascript">
    import Article from "@/mixins/Article.js"
    import Invoice from "@/mixins/Invoice.js"
    import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'ArticleRemise',
		mixins: [Article, Invoice, Navigation],
		props: ['tiers_id'],
		data () {
			return {
				remises: [],
				table_busy: false,
				events_tab: {
                    'TableAction::goToAddRemiseTiers': this.openAddRemiseModal,
                    'TableAction::goToEditRemiseTiers': this.openEditRemiseModal,
                    'TableAction::goToDeleteRemiseTiers': this.delete
                },
                form: {
                	articlestiers_id: 0,
					articlestiers_articles: null,
					articlestiers_discount_type: null,
                	articlestiers_discount_value: 0,
					articlestiers_htunit: 0
                },
                articles: [],
                articles_filtered: [],
                loading_article: false,
                discount_type_formatted: [],
                discount_type: [],
                show_discount: true,
                processing: false,
                show_ae_message: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.remises = await this.getArticlesRemiseTiers(this.tiers_id)
				this.table_busy = false
			},

			openAddRemiseModal() {
				this.form = {
					articlestiers_id: 0,
					articlestiers_articles: null,
					articlestiers_discount_type: null,
                	articlestiers_discount_value: 0,
					articlestiers_htunit: 0
				}
				this.openModal()
			},

			async openEditRemiseModal(remise) {
				await this.openModal()
				const article = this.articles.find(article => article.articles_id == remise.articles_id)
				const discount = this.discount_type.find(discount => discount.invoicediscounttype_id == remise.articlestiers_discount_type)
				this.form = {
					...remise, 
					articlestiers_articles: article,
					articlestiers_discount_type: discount, 
					articlestiers_discount_value: remise.articlestiers_discount_value/100
				}
				this.show_discount = !!remise.articlestiers_discount_type
			},

			async openModal() {
				this.show_ae_message = false
				this.$refs['modal'].show()
				if(this.articles.length == 0) {
					this.loadDiscountType().then(res => {
						this.discount_type = res.map(r => ({...r, invoicediscounttype_label: this.getTrad(r.invoicediscounttype_label)}))
					})

					this.loading_article = true
					this.articles = await this.loadAllArticles()
					for (let i = 0; i < this.articles.length; i++) {
						this.articles[i].ht_format = await this.priceFormat(this.articles[i].articles_ht, this.articles[i].entity_currency, true)
					}
					this.articles_filtered = this.articles
					this.loading_article = false
	            }
			},

			onSearchArticle(query) {
				const search = this.formatSearch(query)
				if(search === '') {
					this.articles_filtered = this.articles
					return
				}
				this.articles_filtered = this.articles.filter(article => this.formatSearch(article.articles_label).indexOf(search) > -1)
			},

			formatSearch(value) {
				if(!value) return ''
				return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim()
			},

			async save() {
				// si c'est une remise unitaire je x100 pour avoir en centime
				let discount_value = 0
				if(this.show_discount) {
					discount_value = this.form.articlestiers_discount_value * 100
				}

				const form = {
					articlestiers_articles: this.form.articlestiers_articles.articles_id,
					articlestiers_discount_type: this.show_discount ? this.form.articlestiers_discount_type.invoicediscounttype_id : null,
                	articlestiers_discount_value: discount_value,
					articlestiers_htunit: this.show_discount ? 0 : this.form.articlestiers_htunit * 100
				}
				this.processing = true
				this.show_ae_message = false
				if(this.form.articlestiers_id == 0) {
					const res = await this.addArticleRemiseTiers(this.tiers_id, form)
					if(res.retour == 'AE') {
						this.show_ae_message = true
						this.processing = false
						return false
					}
				}
				else {
					await this.editArticleRemiseTiers(this.tiers_id, this.form.articlestiers_id, form)
				}
				this.processing = false

				this.$refs['modal'].hide()
				this.init_component()
			},

			async delete(remise) {
				await this.deleteArticleRemiseTiers(this.tiers_id, remise.articlestiers_id)
				this.$refs.tiers_article_remise.unselectAll()
				this.init_component()
			},

			articleUpdated() {
				this.show_ae_message = false
			}
		},

		components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}

</script>